import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Cover from '../../components/cover/cover'
import ContactForm from '../../components/form/form'

// image imports
import cover from "../../images/delhi-cover.jpg"

const DelhiPage = () => (
  <Layout>
    <SEO title="Delhi Chapter" />
    <Cover
      image={cover}
      title={`We Clothe Them, Delhi`}
    />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading `}>Chapters &middot; Delhi</h6>
        <h2 className={``}>About the Chapter</h2>
        <p className={``}>
        WCT is based out of Delhi - the heart of India. Initiated in 2016, our Delhi chapter is headed by Padmini Modi, a lawyer by profession. Numerous collection drives including the ones at University of Delhi (Kirori Mal College, Sri Ram College of Commerce, Jesus and Mary College and NSIT) and other corporate houses have been organized.
        </p>
        <p>We are proud collaborators with Mastercard, Wingify, University of Delhi and many NGOs including Salaam Balak Trust and Delhi Council of Child Care. </p>
        <p>Various donation drives have been organized in the city such as at Earth Saviour Foundation, Sai Old-Age Home, Bal Sahyog, Old Delhi street distribution, Arya Old Delhi etc.</p>
      </div>
    </section>
    <section className={`grey sm`}>
      <div className={`content-sm`}>
        <h2 className={``}>
          <span>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </span>{" "}
          Reach Out
        </h2>
        <div className={`chapter-contact`}>
          <p>Become a part of our pursuit in the city of hearts by collaborating or volunteering in collection drives & donation drives.</p>
          <p>
            <b>Email:</b> delhi@weclothethem.com
          </p>
          <p>
            <b>Contact:</b> +91-9999298196, +91-8700535580{" "}
          </p>
        </div>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section>
  </Layout>
)

export default DelhiPage
